import React from 'react';
import { ArrowLink } from '../../../../../../ui';
import { StyledAction } from './StyledAction';
import { usePartialAmendUrl } from '../helpers/usePartialAmendUrl';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { IBooking } from '../../../../domain/booking/models/IBooking';

interface IPartialAmendActionProps {
	booking: IBooking;
}

export const PartialAmendAction = ({ booking }: IPartialAmendActionProps) => {
	const url = usePartialAmendUrl(booking);
	const { t } = useTranslation();

	return (
		<>
			<StyledAction>
				<ArrowLink href={url}>
					{t('parking_booking_details_modify_personal_details_link')}
				</ArrowLink>
			</StyledAction>
		</>
	);
};
